import React, { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { ErrorRed } from '../../../../assets/icons'
import { Spacer } from '../../../../ui/atoms'
import SubmitButton from '../../../Auth/SubmitButton'
import { PaymentStatusModal } from '../../InvoiceDetails/components/PaymentStatusModal'
import {
  ErrorCodeToStatusMapping,
  IntegrationErrorCodesType,
  IntegrationRedirectStatusesType,
} from '@linqpal/models/src/dictionaries'

interface IIntegrationPaymentErrorModalProps {
  paymentMethodSubtitle?: string
  paymentMethodName?: string
  errorCode: IntegrationErrorCodesType
  onClose: (status: IntegrationRedirectStatusesType) => void
}

export const IntegrationPaymentErrorModal: React.FC<IIntegrationPaymentErrorModalProps> =
  memo(({ onClose, errorCode }) => {
    const { t } = useTranslation('global')

    const status = ErrorCodeToStatusMapping[errorCode]
    const title = status.replace(/([a-z])([A-Z])/g, '$1 $2')
    const subtitle = errorCode

    return (
      <PaymentStatusModal
        headerIcon={<ErrorRed style={{ alignSelf: 'center' }} />}
        footer={
          <>
            <SubmitButton
              style={{ backgroundColor: '#00A0F3' }}
              onPress={() => {
                onClose(status)
              }}
            >
              {t('TabInvoice.go_back_and_try_again')}
            </SubmitButton>
            <Spacer height={20} />
          </>
        }
        // eslint-disable-next-line i18next/no-literal-string
        backgroundColor={'#f5ebec'}
        title={title}
        subtitle={subtitle}
        onClose={() => {
          onClose(status)
        }}
      />
    )
  })
